<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>M. L. Jordan briefly lived on a farm in Perryville, Kentucky close to the Perryville Battlefield. She holds a BA in religious studies from Centre College and is also a graduate of Midway College of Nursing. She was an RN for many years working mainly in the emergency room and as a hospice nurse. She and her husband live on the coast in South Carolina.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?4a9f44d6